/**
 * Resolución del protocolo de reproducción.
 *
 * El protocolo lo define la CONFIGURACIÓN del cliente, no una detección en runtime, y es
 * el MISMO para todos los espectadores de un evento. La razón es de producto: WebRTC
 * entrega a ~1 s y LL-HLS a ~2 s, así que mezclarlos deja a la audiencia desfasada entre sí
 * y este producto tiene chat, stock y productos que se anuncian en vivo.
 *
 * Consecuencia: acá NO hay override por espectador. Si alguien no puede ver, se le muestra
 * un cartel; el protocolo se cambia a nivel compañía como decisión operativa.
 */

export const PLAYBACK_PROTOCOLS = {
  WEBRTC: 'webrtc',
  HLS: 'hls',
}

/**
 * Ante cualquier valor ausente, mal escrito o desconocido se usa WebRTC. Es lo que hace
 * hoy la aplicación, así que un cliente sin el campo configurado —o con un typo en el
 * backend— se comporta exactamente como antes en lugar de quedarse sin video.
 */
export const DEFAULT_PLAYBACK_PROTOCOL = PLAYBACK_PROTOCOLS.WEBRTC

const SUPPORTED = new Set(Object.values(PLAYBACK_PROTOCOLS))

const normalize = (value) => {
  if (typeof value !== 'string') return undefined
  const candidate = value.trim().toLowerCase()
  return SUPPORTED.has(candidate) ? candidate : undefined
}

/**
 * El flag vive en `company.companyConfigurations`, como el resto de los flags del cliente
 * (`productsRepository` y compañía). Es UN SOLO lugar a propósito: la restricción es de la
 * red del cliente y esa negociación con su área de IT es una para toda la empresa — se
 * evaluó un override por tienda y se descartó por innecesario.
 */
export const resolvePlaybackProtocol = (store) =>
  normalize(store?.company?.companyConfigurations?.playbackProtocol) ?? DEFAULT_PLAYBACK_PROTOCOL
